export default {"src":"/_next/static/media/header-logo.a971b02a.svg","height":24,"width":92,"blurWidth":0,"blurHeight":0};